// extracted by mini-css-extract-plugin
export default {"mostPopularCardStack":"MostPopularCardPage_mostPopularCardStack__6UoSO"};